import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    CalendarCheck, Radio, Trophy, Users, LayoutGrid, Clapperboard,
    Target, Eye, ShieldCheck, Mail, Globe, ChevronDown,
    Building2, UserRound, ArrowRight, Sparkles
} from 'lucide-react';
import './Hakkimizda.css';

const FEATURES = [
    { icon: <CalendarCheck size={22} />, title: 'Online Rezervasyon', text: 'Konumunu seç, boş saatleri gör, sahayı anında kirala. Kapora online ödenir, saat sana ayrılır.' },
    { icon: <Radio size={22} />, title: 'Canlı Yayın', text: 'Saha kamerasından maçını gerçek zamanlı yayınla. Gelemeyenler telefondan izlesin.' },
    { icon: <Clapperboard size={22} />, title: 'Maç Arşivi', text: 'Maç bitince kaydı geriye dönük izle ve indir. O golü bir daha, bir daha seyret.' },
    { icon: <Users size={22} />, title: 'Oyuncu Profili & Takip', text: 'Kendi profilini oluştur, mevkiini seç, istatistiklerini tut. Diğer oyuncuları takip et.' },
    { icon: <Trophy size={22} />, title: 'Goller & Haftanın Golü', text: 'En iyi gollerini yükle, beğeni topla. Haftanın en çok beğenilen golü öne çıkar.' },
    { icon: <LayoutGrid size={22} />, title: 'Kadro Kur', text: '6v6\'dan 11v11\'e dizilişini kur, forma rengini seç, kadronu PNG olarak indir ve paylaş.' },
];

const FAQ = [
    {
        q: 'SahaLive tam olarak ne işe yarıyor?',
        a: 'İki şeyi bir araya getiriyor: halı saha rezervasyonu ve oyuncuların sosyal ağı. Bir yandan boş saatlerden online rezervasyon yapıp maçını canlı yayınlayabiliyorsun, diğer yandan profilini oluşturup gollerini paylaşabiliyor, diğer oyuncularla bağlanabiliyorsun.',
    },
    {
        q: 'Oyuncu olarak nasıl kayıt oluyorum?',
        a: 'Google hesabınla giriş yapıyorsun. Ardından adını, konumunu ve mevkiini girip profilini tamamlıyorsun. Ekstra bir şifre veya form yok.',
    },
    {
        q: 'Halı saha sahibiysem sisteme nasıl katılırım?',
        a: 'Giriş ekranından "Sahanı Kaydet" ile başvuru bırakıyorsun. Başvurun onaylandıktan sonra e-postanla giriş yapıp tesis bilgilerini, çalışma saatlerini, fiyatını ve kamera yayınını kendi panelinden yönetiyorsun.',
    },
    {
        q: 'Rezervasyon ödemesi güvenli mi?',
        a: 'Ödeme altyapısı lisanslı bir ödeme kuruluşu üzerinden, 3D Secure ile çalışacak şekilde kuruluyor. Kart bilgilerin SahaLive sunucularında tutulmaz.',
    },
    {
        q: 'Canlı yayın için ne gerekiyor?',
        a: 'Sahada internete bağlı bir kamera. Tesis sahibi kameradan gelen yayını panele bağlıyor; oyuncular ve izleyiciler tarayıcıdan izliyor, ayrı bir uygulama gerekmiyor.',
    },
];

const LEGAL = [
    {
        title: 'KVKK Aydınlatma Metni',
        body: '6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca SahaLive, veri sorumlusu sıfatıyla kişisel verilerinizi yalnızca üyelik işlemlerinin yürütülmesi, hizmet kalitesinin artırılması ve yasal yükümlülüklerin yerine getirilmesi amacıyla işler. Verileriniz açık rızanız olmadan üçüncü kişilerle paylaşılmaz. Detaylı metin yayına alınmadan önce bu bölümde güncellenecektir.',
    },
    {
        title: 'Gizlilik Politikası',
        body: 'Telefon numarası ve e-posta gibi iletişim bilgileri yalnızca hizmetin sunulması için kullanılır. Çerezler oturum güvenliği ve site deneyimi için kullanılır; reklam amaçlı takip yapılmaz.',
    },
    {
        title: 'Kullanıcı Sözleşmesi',
        body: 'Platformu kullanarak site kurallarına uymayı, diğer oyunculara saygılı olmayı ve profilinde doğru bilgi vermeyi kabul edersin. SahaLive; spam, hakaret veya sahte profil tespit edilen hesapları askıya alma hakkını saklı tutar.',
    },
];

const Hakkimizda = () => {
    const [openFaq, setOpenFaq] = useState(0);
    const [openLegal, setOpenLegal] = useState(null);

    return (
        <div className="ab-page">

            {/* HERO */}
            <section className="ab-hero">
                <span className="ab-eyebrow"><Sparkles size={14} /> Halı Sahanın Dijital Evi</span>
                <h1>Sahayı kirala, maçını yayınla,<br /><span>yıldızın ol.</span></h1>
                <p>
                    SahaLive; halı saha rezervasyonunu, canlı yayını ve oyuncuların sosyal ağını
                    tek bir yerde toplayan bir platform. Amatör futbolu profesyonel imkânlarla buluşturuyoruz.
                </p>
                <div className="ab-hero-actions">
                    <Link to="/reservation" className="ab-btn ab-btn-primary">
                        Rezervasyon Yap <ArrowRight size={16} />
                    </Link>
                    <Link to="/market" className="ab-btn ab-btn-ghost">Saha Yıldızları</Link>
                </div>
            </section>

            {/* BİZ KİMİZ */}
            <section className="ab-section">
                <div className="ab-story">
                    <div className="ab-story-head">
                        <h2>Biz kimiz?</h2>
                    </div>
                    <div className="ab-story-body">
                        <p>
                            Her hafta sahaya çıkan, "adam eksik" mesajlarıyla uğraşan, attığı golü kimseye
                            gösteremeyen oyuncular olarak yola çıktık. Halı saha kültürü Türkiye'de çok büyük
                            ama dijital tarafı hep eksik kaldı.
                        </p>
                        <p>
                            SahaLive bu boşluğu dolduruyor: sahanı saniyeler içinde rezerve et, maçını
                            kaydet ve canlı yayınla, gollerini paylaş, diğer oyuncularla bağlan. İşletmeler
                            için de rezervasyon, doluluk ve finans takibini tek panele indiriyoruz.
                        </p>
                    </div>
                </div>
            </section>

            {/* NASIL ÇALIŞIR */}
            <section className="ab-section">
                <div className="ab-section-head">
                    <h2>Nasıl çalışır?</h2>
                    <p>Üç adımda sahadan ekrana.</p>
                </div>
                <div className="ab-steps">
                    <div className="ab-step">
                        <span className="ab-step-no">1</span>
                        <h3>Sahanı bul & rezerve et</h3>
                        <p>Konumunu seç, boş saatleri gör, online kapora ile saatini ayır.</p>
                    </div>
                    <div className="ab-step">
                        <span className="ab-step-no">2</span>
                        <h3>Maçını yayınla & kaydet</h3>
                        <p>Saha kamerasıyla maçı canlı yayınla; kayıt otomatik arşive düşsün.</p>
                    </div>
                    <div className="ab-step">
                        <span className="ab-step-no">3</span>
                        <h3>Paylaş & yıldız ol</h3>
                        <p>Gollerini yükle, beğeni topla, profilinde istatistiklerini büyüt.</p>
                    </div>
                </div>
            </section>

            {/* NE SUNUYORUZ */}
            <section className="ab-section">
                <div className="ab-section-head">
                    <h2>Ne sunuyoruz?</h2>
                    <p>Tek platform, sahanın her tarafı.</p>
                </div>
                <div className="ab-features">
                    {FEATURES.map((f) => (
                        <div className="ab-feature" key={f.title}>
                            <div className="ab-feature-icon">{f.icon}</div>
                            <h3>{f.title}</h3>
                            <p>{f.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* KİMLER İÇİN */}
            <section className="ab-section">
                <div className="ab-audience">
                    <div className="ab-audience-card">
                        <div className="ab-audience-icon"><UserRound size={24} /></div>
                        <h3>Oyuncular için</h3>
                        <p>
                            Profil, takip, gol paylaşımı, kadro kurma ve maç arşivi. Sahadaki performansını
                            görünür kıl, takımını kur, en iyi anlarını sakla.
                        </p>
                        <Link to="/market" className="ab-inline-link">Saha Yıldızları'na göz at <ArrowRight size={14} /></Link>
                    </div>
                    <div className="ab-audience-card">
                        <div className="ab-audience-icon"><Building2 size={24} /></div>
                        <h3>Halı saha işletmeleri için</h3>
                        <p>
                            Online rezervasyon, doluluk takvimi, canlı yayın yönetimi ve günlük/aylık
                            finans raporu. Boş saatlerini doldur, tesisini dijitale taşı.
                        </p>
                        <Link to="/giris" className="ab-inline-link">Sahanı kaydet <ArrowRight size={14} /></Link>
                    </div>
                </div>
            </section>

            {/* MİSYON & VİZYON */}
            <section className="ab-section">
                <div className="ab-mv">
                    <div className="ab-mv-card">
                        <div className="ab-mv-icon"><Target size={26} /></div>
                        <h3>Misyonumuz</h3>
                        <p>
                            Maç organizasyonunu saniyeler meselesi haline getirmek, amatör futbolu
                            kayıt altına almak ve her oyuncuya sahnesini vermek.
                        </p>
                    </div>
                    <div className="ab-mv-card">
                        <div className="ab-mv-icon"><Eye size={26} /></div>
                        <h3>Vizyonumuz</h3>
                        <p>
                            Türkiye'nin dört bir yanında "halı saha" denince akla gelen ilk dijital
                            platform olmak.
                        </p>
                    </div>
                </div>
            </section>

            {/* SSS */}
            <section className="ab-section">
                <div className="ab-section-head">
                    <h2>Sık sorulan sorular</h2>
                </div>
                <div className="ab-accordion">
                    {FAQ.map((item, i) => (
                        <div className={`ab-acc-item ${openFaq === i ? 'open' : ''}`} key={i}>
                            <button className="ab-acc-head" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                                <span>{item.q}</span>
                                <ChevronDown size={18} className="ab-acc-chevron" />
                            </button>
                            {openFaq === i && <div className="ab-acc-body">{item.a}</div>}
                        </div>
                    ))}
                </div>
            </section>

            {/* İLETİŞİM */}
            <section className="ab-section">
                <div className="ab-contact">
                    <h2>Bize ulaşın</h2>
                    <p>Soru, öneri, iş birliği veya saha başvurusu — yaz, dönelim.</p>
                    <div className="ab-contact-links">
                        <a href="mailto:destek@sahalive.com" className="ab-contact-chip">
                            <Mail size={18} /> destek@sahalive.com
                        </a>
                        <a href="https://sahalive.com" target="_blank" rel="noreferrer" className="ab-contact-chip">
                            <Globe size={18} /> sahalive.com
                        </a>
                    </div>
                    <a href="mailto:destek@sahalive.com" className="ab-btn ab-btn-primary ab-contact-btn">
                        E-posta Gönder <ArrowRight size={16} />
                    </a>
                </div>
            </section>

            {/* YASAL */}
            <section className="ab-section ab-legal">
                <div className="ab-section-head">
                    <h2>Yasal bilgilendirme</h2>
                    <p>Şeffaflık ilkemiz gereği süreçlerimiz aşağıda. Yayına alınmadan önce güncellenecektir.</p>
                </div>
                <div className="ab-accordion">
                    {LEGAL.map((item, i) => (
                        <div className={`ab-acc-item ${openLegal === i ? 'open' : ''}`} key={i}>
                            <button className="ab-acc-head" onClick={() => setOpenLegal(openLegal === i ? null : i)}>
                                <span className="ab-acc-legal-title"><ShieldCheck size={16} /> {item.title}</span>
                                <ChevronDown size={18} className="ab-acc-chevron" />
                            </button>
                            {openLegal === i && <div className="ab-acc-body">{item.body}</div>}
                        </div>
                    ))}
                </div>
            </section>

        </div>
    );
};

export default Hakkimizda;
